import { useState, useCallback } from "react";
import API_ROUTES from "./apiRoutes";

export const useUsers = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [users, setUsers] = useState([]);
    const [success, setSuccess] = useState(false);
    const [totalCount, setTotalCount] = useState(0);

    const getToken = () => localStorage.getItem("token");

    const resetStates = useCallback(() => {
        setLoading(false);
        setError(null);
        setSuccess(false);
    }, []);

    const fetchUsers = useCallback(async ({ search = '', page = 1, size = 10 } = {}) => {
        resetStates();
        setLoading(true);

        try {
            const url = `${API_ROUTES.USERS.list()}?search=${encodeURIComponent(search)}&page=${page}&size=${size}`;
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${getToken()}`,
                    "Content-Type": "application/json",
                },
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Erro ao buscar usuários.");
            }
            setUsers(data.users);
            setTotalCount(data.count || 0);
            setSuccess(true);
        } catch (err) {
            setError(err.message || "Erro ao buscar usuários.");

        } finally {
            setLoading(false);
        }
    }, [resetStates]);

    const deleteUser = useCallback(async (userId) => {
        resetStates();
        setLoading(true);

        try {
            const response = await fetch(API_ROUTES.USERS.delete(userId), {
                method: "DELETE",
                headers: {
                    "Authorization": `Bearer ${getToken()}`,
                    "Content-Type": "application/json",
                }
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Erro ao deletar usuário.");
            }

            await fetchUsers();
            setSuccess(true);
        } catch (err) {
            setError(err.message || "Erro ao deletar usuário.");
        } finally {
            setLoading(false);
        }
    }, [resetStates, fetchUsers]);

    const updateUser = useCallback(async (userId, userData) => {
        resetStates();
        setLoading(true);

        try {
            const response = await fetch(API_ROUTES.USERS.update(userId), {
                method: "PUT",
                headers: {
                    "Authorization": `Bearer ${getToken()}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(userData)
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Erro ao atualizar usuário.");
            }

            await fetchUsers();
            setSuccess(true);
        } catch (err) {
            setError(err.message || "Erro ao atualizar usuário.");
        } finally {
            setLoading(false);
        }
    }, [resetStates, fetchUsers]);

    const createUser = useCallback(async (userData) => {
        resetStates();
        setLoading(true);

        try {
            const response = await fetch(API_ROUTES.USERS.create(), {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${getToken()}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(userData)
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Erro ao criar usuário.");
            }

            await fetchUsers();
            setSuccess(true);
        } catch (err) {
            setError(err.message || "Erro ao criar usuário.");
        } finally {
            setLoading(false);
        }
    }, [resetStates, fetchUsers]);

    return {
        users,
        loading,
        error,
        success,
        totalCount,
        fetchUsers,
        deleteUser,
        updateUser,
        createUser
    };
}; 